/* eslint 'jsx-a11y/alt-text': 'off' */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { getUserPreferences, getUserDetailsAfterLogin } from 'action/cultureAction';
import { GetEmployeeTenantDetail } from 'action/facilitiesAction';
import styles from './shared.module.css';
import user_svg from 'Assets/images/user-circle-o.svg';
import user_svg1 from 'Assets/images/user-circle-oc.svg'
import { GetInvoiceLogo } from 'action/invoiceAction';


class Header extends Component {
    componentWillMount() {
        this.props.getUserDetailsAfterLogin();
        this.props.getUserPreferences();
        this.props.GetInvoiceLogo();
        let employeeID = null;
        employeeID = localStorage.getItem('TenantUserID');
        if(employeeID!==null){
            this.props.GetEmployeeTenantDetail(employeeID);
        }
    }

    constructor(props){
        super(props);
        this.state={
            toggle:false
        };
        this.dropdowntoggle = this.dropdowntoggle.bind(this);
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    };

    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside);
    };

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    };
  
    
    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    handleClickOutside(event) {
        if (this.wrapperRef.context.isOpen === false) {
            this.setState({toggle:false});
        }
    };

    dropdowntoggle(){
        this.setState({toggle:!this.state.toggle});
    };

   
    render() {
        let username,logo = null;

        let { userProfileDetails,headerLogo } = this.props;

      

        //header Logo
        logo = (headerLogo !==null)? (<img src={headerLogo} className={styles.header_img}/>) : null;  

        //Display First Name and Last name  
        username = (userProfileDetails !== undefined && userProfileDetails.user_info !== undefined && userProfileDetails.user_info.firstName !== undefined) ?  userProfileDetails.user_info.firstName + " " + userProfileDetails.user_info.lastName : "";

        return (
            <div className={styles.header}>

                <div className={styles.header_logo}>{logo} </div>                               {/* Header Logo */}

                <ul className={styles.desktop_header_items}>                                                     {/* Desktop Header Items  */}
                    <li className={styles.desktop_header_username}> {username}  </li>
                    <li className={styles.desktop_header_divider} ></li>
                    <li className={styles.desktop_header_logout}> <Link to="/FacilityManagementLogout" className={styles.desktop_header_logout}> {"Logout"}</Link> </li>
                </ul>

                <div className={styles.mobile_header_items}>                                                            {/* Mobile Header Items  */}
                <UncontrolledDropdown nav inNavbar>
                    <DropdownToggle nav style={{float:'right',marginTop:'15px'}}  ref={this.setWrapperRef} onClick={this.dropdowntoggle} className={(!this.state.toggle) ? styles.mobile_header_bgcolor: styles.mobile_header_bgcolorchange}>
                    {(!this.state.toggle) ? <img src={user_svg}/>:<img src={user_svg1}/> } 
                        <span className={(!this.state.toggle) ? styles.mobile_header_arrow_down : styles.mobile_header_arrow_up}></span>
                    </DropdownToggle>
                    <DropdownMenu right className={styles.mobile_header_dropdown}>
                        <DropdownItem style={{backgroundColor:'#61AE34',pointerEvents: 'none',color:'#ffffff',fontSize:'12px',fontFamily:'Verdana'}}>
                            {username.substring(0,29)}
                        </DropdownItem>
                        <Link to="/FacilityManagementLogout" style={{ "color": "black" }} >
                            <DropdownItem style={{backgroundColor:'#DAE2D0'}}>
                                {"Logout"}
                            </DropdownItem>
                        </Link>
                    </DropdownMenu>
                </UncontrolledDropdown>
                </div>

            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        userProfileDetails: state.userDetailsRootReducer,
        headerLogo: state.InvoiceRootReducer.Invoicelogo,
        userPrefs: state.userPreferencesRootReducer.UserPreference,
        employeeTenantDetails: state.FacilityRequestsEmployeeTenantDetails.EmployeeTenantDetails
    };
};
const mapDispatchToProps = dispatch => {
    return {
        getUserDetailsAfterLogin: () => dispatch(getUserDetailsAfterLogin()),
        getUserPreferences: () => dispatch(getUserPreferences()),
        GetInvoiceLogo: () => dispatch(GetInvoiceLogo()),
        GetEmployeeTenantDetail: (employeeID) => dispatch(GetEmployeeTenantDetail(employeeID)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);